/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Field_IncotermInputs */

const en_po_field_incoterm = /** @type {(inputs: Po_Field_IncotermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incoterm`)
};

/**
* | output |
* | --- |
* | "Incoterm" |
*
* @param {Po_Field_IncotermInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_field_incoterm = /** @type {((inputs?: Po_Field_IncotermInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Field_IncotermInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_field_incoterm(inputs)
});